import React, { useEffect, useState } from 'react'

export const UserIdContext = React.createContext<string | undefined>(undefined)

export const UserIdProvider: React.FC = ({ children }) => {
  const [userId, setUserId] = useState('')

  useEffect(() => {
    const queryParam = new URLSearchParams(window.location.search)
    const userId = queryParam.get('userId')

    if (!userId) {
      throw new Error('Patient ID is not provided')
    }

    setUserId(userId)
  }, [])

  return <UserIdContext.Provider value={userId}>{children}</UserIdContext.Provider>
}
